module.exports = __webpack_public_path__ + "static/assets/44a71e47e7da9c14b0feb31028c281e5.png";